// Special StyledComponent that handles global styles
// https://www.styled-components.com/docs/api#createglobalstyle

import { createGlobalStyle } from 'styled-components';
import { normalize } from 'polished';

const GlobalStyle = createGlobalStyle`
  ${normalize()}
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    font-family: ${props => props.theme.type
    .base}, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width:100%;
    height: 100%;
    font-size: 16px;
    background-color: ${props => props.theme.components.layout.backgroundColor};
    color: ${props => props.theme.colors.black};
  }

  #root {
    height: 100%;
    width: 100%;
  }

  #portal {
    position: absolute;
    z-index: ${props => props.theme.values.zIndex.superBig};
  }

  a {
    color: ${props => props.theme.colors.base};
    font-weight: ${props => props.theme.weight.light};
    font-size: ${props => props.theme.sizes.s};
  }

  .isEditable:hover {
    outline: 0px;
    cursor: text;
  }

  .isEditable--editing {
    outline: 1px solid ${props => props.theme.colors.primary};
    cursor: text;
  }

  html [type="button"] {
    -webkit-appearance: none;
  }
`;

export const GlobalStyleStorybook = createGlobalStyle`
  ${normalize()}
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
´ html, body {
    height: 100%;
    width: 100%;
  }

  html, body {
    font-family: ${props => props.theme.type
    .base}, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width:100%;
    height: 100%;
    font-size: 16px;
    color: ${props => props.theme.colors.black};
  }

  #root {
    height: 100%;
    width: 100%;
  }

  #portal {
    position: absolute;
    z-index: ${props => props.theme.values.zIndex.l};
  }

  a {
    color: ${props => props.theme.colors.base};
    font-weight: ${props => props.theme.weight.light};
    font-size: ${props => props.theme.sizes.s};
  }
`;

export default GlobalStyle;
